import * as config from '../config';
import MemoryCache from '../MemoryCache';
import SkuData from './SkuData';
import TsvDataSource from './TsvDataSource';
import mfac from '../MaterialFactory';
import { MeshStandardMaterial } from 'three';
// @ts-ignore because the language server is not going to understand this
import { data as cabinetData } from './jarlin_cabinets.tsv'; // @ts-ignore
// @ts-ignore
import { data as lineData } from './jarlin_lines.tsv';

export const cabinets = new SkuData(new TsvDataSource(cabinetData));
export const lines = new SkuData(new TsvDataSource(lineData));

export const cabinetWidth = (sku: string) => cabinets.number(sku, 'width')
export const cabinetHeight = (sku: string) => cabinets.number(sku, 'height')
export const cabinetDepth = (sku: string) => cabinets.number(sku, 'depth')

export const lineMaterial = MemoryCache.memoize((line: string) => {
    const solid = lines.boolean(line, 'solid');
    if(solid) {
        return new MeshStandardMaterial({
            color: lines.string(line, 'color'),
            roughness: 0.2,
        });
    } else {
        return new MeshStandardMaterial({
            map: mfac.preloadTexture(
                `${config.maps}/${lines.string(line, 'color_map')}`),
            roughness: 0.2,
        });
    }
});
